import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import LoanTableRecords from '../LoansTableRecords';

const DeclinedLoans = () => (
  <LoanTableRecords defaultUrl={AdminRouteName.declinedLoansRoute} tabStatus="CANCELLED" toggleStorageId="declined-loan-table-col" hasNameAndImage permissionName="can-view-declined-credit-request" />

);

export default DeclinedLoans;
